export const COOKIE_POLICY_VERSION = "1.0-2026-06";
export const PRIVACY_POLICY_VERSION = "1.0-2026-06";
const KEY = "ap_cookie_consent";
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function getConsent() {
  try {
    const c = JSON.parse(localStorage.getItem(KEY) || "null");
    return c && c.version === COOKIE_POLICY_VERSION ? c : null;
  } catch {
    return null;
  }
}

export const hasAnalyticsConsent = () => getConsent()?.analytics === true;

export function saveConsent({ analytics, marketing }) {
  const c = { version: COOKIE_POLICY_VERSION, date: new Date().toISOString(), necessary: true, analytics: !!analytics, marketing: !!marketing };
  localStorage.setItem(KEY, JSON.stringify(c));
  if (!c.analytics) {
    localStorage.removeItem("ap_sid");
    try { window.posthog?.opt_out_capturing?.(); } catch { /* noop */ }
  } else if (window.__apLoadPosthog) {
    window.__apLoadPosthog();
    try { window.posthog?.opt_in_capturing?.(); } catch { /* noop */ }
  }
  fetch(`${BACKEND}/api/consent/cookies`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ analytics: c.analytics, marketing: c.marketing }),
    keepalive: true,
  }).catch(() => {});
  window.dispatchEvent(new CustomEvent("ap-consent-change", { detail: c }));
  return c;
}

export const openCookieSettings = () => window.dispatchEvent(new Event("ap-open-cookie-settings"));
